<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
    >
        <g clip-path="url(#clip0_199_30)">
            <path
                d="M1.7414 12.0002C1.29668 12.0002 0.849509 11.8433 0.510442 11.5273C-0.170147 10.8977 -0.170147 9.87931 0.510442 9.24964L9.99693 0.472981C10.6775 -0.156684 11.7783 -0.156684 12.4588 0.472981C13.1394 1.10265 13.1394 2.12102 12.4588 2.75068L2.97236 11.5273C2.63329 11.841 2.18612 12.0002 1.7414 12.0002Z"
                fill="url(#paint0_linear_199_30)"
            />
            <path
                d="M8.77112 12C8.32641 12 7.87923 11.8432 7.54017 11.5272C6.85958 10.8976 6.85958 9.87918 7.54017 9.24952L17.0291 0.472859C17.7097 -0.156806 18.8104 -0.156806 19.491 0.472859C20.1716 1.10252 20.1716 2.1209 19.491 2.75056L10.0045 11.5295C9.66547 11.8432 9.2183 12.0023 8.77358 12.0023L8.77112 12Z"
                fill="url(#paint1_linear_199_30)"
            />
            <path
                d="M11.2289 3.22106H5.53108C4.57039 3.22106 3.78906 2.50047 3.78906 1.6094C3.78906 0.718318 4.56793 0 5.53108 0H11.2289C12.1896 0 12.9709 0.720591 12.9709 1.61167C12.9709 2.50275 12.192 3.22334 11.2289 3.22334V3.22106Z"
                fill="url(#paint2_linear_199_30)"
            />
            <path
                d="M14.4695 11.9999H8.77171C7.81102 11.9999 7.02969 11.2794 7.02969 10.3883C7.02969 9.4972 7.80856 8.77661 8.77171 8.77661H14.4695C15.4302 8.77661 16.2115 9.4972 16.2115 10.3883C16.2115 11.2794 15.4326 11.9999 14.4695 11.9999Z"
                fill="url(#paint3_linear_199_30)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_199_30"
                x1="1.07461"
                y1="11.1247"
                x2="9.858"
                y2="1.36354"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#19DB9B" />
                <stop offset="1" stop-color="#07A360" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_199_30"
                x1="18.9513"
                y1="0.8034"
                x2="10.0622"
                y2="10.9451"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#19DB9B" />
                <stop offset="1" stop-color="#07A360" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_199_30"
                x1="3.78906"
                y1="1.61167"
                x2="12.9709"
                y2="1.61167"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#23E27D" />
                <stop offset="1" stop-color="#19DB9B" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_199_30"
                x1="7.03215"
                y1="10.3883"
                x2="16.2115"
                y2="10.3883"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#19DB9B" />
                <stop offset="1" stop-color="#23E27D" />
            </linearGradient>
            <clipPath id="clip0_199_30">
                <rect width="20" height="12" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
